import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, ViewChild} from '@angular/core';
import {GuessModifier, GuessType} from "../../../../backend/state/game-state.model";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {GameStateStore} from "../../../store/game-state.store";
import {Item} from "spin-wheel-ts";
import {MatDialogRef} from "@angular/material/dialog";
import {LobbyStore} from "../../../store/lobby.store";
import {GameSettingsStore} from "../../../store/game-settings.store";
import {AnimationStep, HideDialogStep, Sequence} from "../../../shared/util/sequence.util";

interface ItemWithIcon extends Item {
  icon: string;
}

@Component({
  selector: 'app-game-next-round-dialog',
  imports: [
    TranslateModule
  ],
  templateUrl: './game-next-round-dialog.component.html',
  styleUrl: './game-next-round-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GameNextRoundDialogComponent implements AfterViewInit {

  private readonly settingsStore = inject(GameSettingsStore);
  private readonly lobbyStore = inject(LobbyStore);
  private readonly gameStore = inject(GameStateStore);
  private readonly translate = inject(TranslateService);

  @ViewChild('type') typeElement!: ElementRef;
  @ViewChild('wheel') wheelElement!: ElementRef;
  @ViewChild('wheelContainer') wheelContainerElement!: ElementRef<HTMLElement>;

  wheel?: any;

  icons: { [key: string]: string } = {
    'CHRONOLOGICAL': 'sort',
    'DECADE': 'event',
    'DIFFERENCE': 'exposure',
    'ARTIST': 'face',
    'BEFORE_AFTER': 'compare_arrows',
    'OLDER_NEWER': 'history',
    'COUNTRY': 'public'
  }

  items: Partial<ItemWithIcon>[] = Object.keys(GuessType).map(key => {
    return {
      value: key,
      label: this.translate.instant(`game.guess.types.${key}.name`),
      icon: this.icons[key]
    }
  });

  icon?: string;

  roundCount = this.gameStore.roundCount;

  cutoffYear = this.gameStore.cutoffYear;

  guessTitleParams = this.gameStore.guessTitleParams;

  guessType = this.gameStore.guessType;

  guessModifier = this.gameStore.guessModifier;

  guessModifiers = GuessModifier;


  constructor(private ref: MatDialogRef<any>) {
  }

  ngAfterViewInit() {
    new Sequence([
      1000,
      new AnimationStep(this.typeElement, {animation: 'bounceIn'}),
      2000,
      new HideDialogStep(this.ref)
    ]).execute();
  }

  close() {
    this.ref.close();
  }
}
